// // Imports
// import { isDevelopment, listToArray } from 'src/lib/utils.js';

// (function(){
//     'use strict';

//     // Save course filter preference
//     jcu_js_v1.fn.saveCourseFilterPreference = function(event) {
//         var target_input = event['target'];
//         var input_id = target_input.getAttribute('id');

//         // Decide what to do with the input event
//         switch(input_id) {
//             case 'domestic-applicants':
//             case 'international-applicants':
//                 if(target_input['checked']) {
//                     jcu_js_v1.fn.saveCourseFilterLocation(input_id);
//                 }                
//                 break;
//         }
//     };

//     // Save course filter location preference
//     jcu_js_v1.fn.saveCourseFilterLocation = function(location_type) {
//         var geolocation_cookie_data = jcu_js_v1.fn.getGeolocationCookieData();
//         var cookie_name = geolocation_cookie_data['name'];
//         var geolocation_cookie = geolocation_cookie_data['cookie'];

//         if(geolocation_cookie !== null) {
//             // Cookie present
//             // Set the manual preference
//             if(location_type === 'domestic-applicants') {
//                 geolocation_cookie['preference'] = 'DOM';
//             } else {
//                 geolocation_cookie['preference'] = 'INTL';
//             }
//         }

//         // Set the cookie data
//         if(isDevelopment()) {
//             jcu_js_v1.fn.bake_local_cookie(cookie_name, geolocation_cookie);
//         } else {
//             jcu_js_v1.fn.bake_cookie(cookie_name, geolocation_cookie);
//         }
//     };

//     // Update the course filter options
//     jcu_js_v1.fn.autoUpdateCourseFilter = function() {
//         var location_identifier = '.jcu-v1__search__checks--location';
//         var location_filter = document.querySelector(location_identifier);

//         if(location_filter !== null) {
//             var cookie_name = 'jcu_geodata';
//             var geolocation_cookie = jcu_js_v1.fn.read_cookie(cookie_name);
//             var domestic_toggle = 'domestic-applicants';
//             var international_toggle = 'international-applicants';

//             if(geolocation_cookie !== null) {
//                 // Check for personal preferences
//                 var preference = geolocation_cookie['preference'];
//                 var target_input = document.querySelector(location_identifier + ' #' + domestic_toggle);

//                 if(preference === 'INTL') {
//                     target_input = document.querySelector(location_identifier + ' #' + international_toggle);
//                 }
                
//                 // Click the target input if not already set
//                 if(!target_input['checked']) {
//                     // Don't scroll to top
//                     jcu_js_v1.vars.search.scroll_to_top = false;

//                     // Click the input
//                     target_input.click();
//                 }
//             }
//         }
//     };


//     //
//     // Ready
//     //

//     // Check for breadcrumbs
//     if(document.querySelector('.jcu-v1__search__checks--location') !== null) {
//         // Update the front-end 
//         jcu_js_v1.fn.autoUpdateCourseFilter();

//         // Set up events for course filter toggles
//         var course_filter_options = listToArray(document.querySelectorAll('.jcu-v1__search__checks input'));
        
//         course_filter_options.forEach(function(option){
//             option.addEventListener('click', jcu_js_v1.fn.saveCourseFilterPreference);
//         });
//     }    
     
// }());
